import script from "./OfCreateBusinessPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./OfCreateBusinessPayment.vue?vue&type=script&setup=true&lang=js"

import "./OfCreateBusinessPayment.vue?vue&type=style&index=0&id=7fbc41b7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fbc41b7"]])

export default __exports__